import djtFinservLogo from "../../../Assets/Images/DJT Finserv logo.png";
import QR from "../../../Assets/Images/QR.png";
import QrDeerika from "../../../Assets/Images/QrDeerika.png";
import QrDjtCorp from "../../../Assets/Images/QrDjtcorp.png";
import QrHob from "../../../Assets/Images/QrHob.png";
import djtDeerikaLogo from "../../../Assets/Images/Deerika logo.png";
import djtHobLogo from "../../../Assets/Images/hob.png";
import djt from "../../../Assets/Images/djt.png";
// import profileImage from "../../../Assets/Images/profile-image.png";

const IdCard = ({ item }) => {
  console.log(item);

  const name = `${item?.name?.first_name} ${
    item?.name?.middle_name ? item?.name?.middle_name : ""
  } ${item?.name?.last_name}`;

  const designation = item?.designation ? item?.designation : "";

  const employeeId = item?.employee_id ? item?.employee_id : "";

  const mobileNo = item?.mobile ? item?.mobile : "";

  const email = item?.email?.company ? item?.email?.company : "";

  const profileImage = item?.photo_url ? item?.photo_url : "";

  return (
    <div className="id-parent">
      {/* finserv */}
      {item?.company === "DJT Financial Services Pvt Ltd" && (
        <div className="id-card">
          <img
            src={djtFinservLogo}
            width="76px"
            height="84px"
            alt="DJT"
            className="finserv-logo"
          />
          <div className="finerv-image">
            <img src={profileImage} alt="image" className="finerv-emp-image" />
          </div>
          <div className="finerv-name text-center">{name}</div>
          <div className="finerv-des text-center">{designation}</div>
          <div className="finerv-empid text-center">
            Emp. Id. : <b>{employeeId}</b>
          </div>
          <div className="finserv-footer-parent">
            <div className="finserv-footer finserv-footer1"></div>
            <div className="finserv-footer finserv-footer2"></div>
            <div className="finserv-footer finserv-footer3"></div>
            <div className="finserv-footer finserv-footer4"></div>
          </div>
        </div>
      )}

      {/* deerika */}
      {item?.company === "DJT Retailers Pvt Ltd" && (
        <div className="id-card mb-2">
          <img
            src={djtDeerikaLogo}
            width="144px"
            height="36px"
            alt="DJT"
            className="deerika-logo"
          />
          <div className="deerika-box"></div>
          <div className="deerika-circle">
            <img src={profileImage} alt="image" className="deerika-emp-image" />
          </div>
          <div className="deerika-name text-center">{name}</div>
          <div className="deerika-des text-center">{designation}</div>
          <div className="deerika-t deerika-tmw">T: +91 {mobileNo}</div>
          <div className="deerika-m deerika-tmw">M: {email}</div>
          <div className="deerika-w deerika-tmw">W: www.deerika.in</div>
          <div className="deerika-address">
            DJT Retailers Pvt. Ltd. Lucerna Tower, 8th Floor, Plot-A2B,
            Sector-125, Noida, Uttar Pradesh - 201301
          </div>
          <img
            src={QrDeerika}
            width="75px"
            height="72px"
            alt="DJT"
            className="qr"
          />
        </div>
      )}
      {/* hob */}
      {item?.company === "DJT Fashion Pvt Ltd" && (
        <div className="id-card mb-2">
          <img
            src={djtHobLogo}
            width="133px"
            height="65px"
            alt="DJT"
            className="hob-logo"
          />
          <div className="deerika-box hob-box"></div>
          <div className="deerika-circle hob-circle">
            <img src={profileImage} alt="image" className="deerika-emp-image" />
          </div>
          <div className="deerika-name text-center">{name}</div>
          <div className="deerika-des text-center">{designation}</div>
          <div className="deerika-t deerika-tmw hob-tmw">T: +91 {mobileNo}</div>
          <div className="deerika-m deerika-tmw hob-tmw">M: {email}</div>
          <div className="deerika-w deerika-tmw hob-tmw">
            W: www.houseofbelieve.com
          </div>
          <div className="deerika-address hob-tmw">
            DJT Retailers Pvt. Ltd. Lucerna Tower, 8th Floor, Plot-A2B,
            Sector-125, Noida, Uttar Pradesh - 201301
          </div>
          <img
            src={QrHob}
            width="71px"
            height="67px"
            alt="DJT"
            className="qr hob-qr"
          />
          <div className="corner top-left-corner"></div>
          <div className="corner top-right-corner"></div>
          <div className="corner bottom-left-corner"></div>
          <div className="corner bottom-right-corner"></div>
        </div>
      )}
      {/* corp */}
      {item?.company === "DJT Corporation and Investment Pvt Ltd" && (
        <div className="id-card mb-2">
          <div className="corp-box"></div>
          <div className="corp-img-box">
            <img src={profileImage} alt="image" className="corp-emp-image" />
          </div>
          <div className="corp-name">{name}</div>
          <div className="corp-id">{employeeId}</div>
          <div className="corp-t corp-tmw">T: +91 {mobileNo}</div>
          <div className="corp-m corp-tmw">M: {email}</div>
          <div className="corp-w corp-tmw">W: www.djtcorp.com</div>
          <div className="corp-address">
            DJT Corporation & Investments, Lucerna Tower, 8th Floor, Plot No-
            A2B, Sector- 125, Noida, Uttar Pradesh - 201301
          </div>
          <img
            src={QrDjtCorp}
            width="75px"
            height="72px"
            alt="DJT"
            className="qr corp-qr"
          />
          <img
            src={djt}
            width="80.41px"
            height="41.96px"
            alt="DJT"
            className="djt"
          />
        </div>
      )}
      {/* back */}
      <div className="id-card mb-2">
        <div className="back-head text-center">
          <b>INSTRUCTIONS</b>
        </div>
        <div className="back-para1">
          This card is the property of {item?.company}. Ltd. to whom it must be
          returned upon request or if found.
        </div>
        <div className="back-para2">This card is non transferable.</div>
        <div className="back-para3">
          In case of loss of this card, please inform the same in writing to HR
          Department.
        </div>
        <div className="back-para4">
          If this card is found, please return the same to HR at address given
          below:
        </div>
        <div className="back-para5 text-center">
          <b>{item?.company}.</b>
        </div>
        <div className="back-para6 text-center">
          Lucerna Tower, 8th Floor, Plot No- A2B, Sector- 125, Noida, Uttar
          Pradesh - 201301 Email- hr@djtcorp.in, Tel.: +91-1206846200
        </div>
        <div className="back-para7 text-center">
          <b>PERSONAL INFORMATION</b>
        </div>
        <div className="back-para8">
          <b>Blood Group :</b> {item?.blood_group}
        </div>
        <div className="back-para9">
          <div>
            <b>Emergency Contact No.:</b>
          </div>
          <div> +91 {item?.emergency_contact}</div>
        </div>
      </div>
    </div>
  );
};

export default IdCard;
